module.exports = __webpack_public_path__ + "static/media/888197_flag_512x512.e7873d72.png";